module.exports = __webpack_public_path__ + "static/media/online.6c2ed93f.wav";